import type { DataItem } from '@pn/core/domain/data';
import { useBuildSliceSelector } from '@pn/services/redux/useBuildSliceSelector';
import { isNil } from 'lodash-es';
import { store } from 'src/application/storage/store';
import { formationsStatsSlice } from './formationsStatsSlice';

export const useFormationsStatsStorage = () => {
  const { name, getInitialState } = formationsStatsSlice;

  const useSliceSelector = useBuildSliceSelector(name, getInitialState());

  return {
    isFetching: useSliceSelector((state) => state.isFetching),
    isError: useSliceSelector((state) => state.isError),
    stats: useSliceSelector((state) => state.stats),
    loadedFormationIds: useSliceSelector((state) => state.loadedFormationIds),
  };
};

export const formationsStatsActions = () => {
  const { dispatch, getState } = store;
  const { actions, name } = formationsStatsSlice;

  if (isNil(getState()[name])) {
    throw new Error(`[${name}] reducer has not been injected yet`);
  }

  return {
    receive: (formationId: string, stats: DataItem[]) =>
      dispatch(actions.receive({ formationId, stats })),
    request: () => dispatch(actions.request()),
    error: () => dispatch(actions.error()),
    reset: () => dispatch(actions.reset()),
  };
};
